import {Environment} from '@libs/utils/shared';

export const environment = new Environment({
    projectSettings: {},
    sdkBaseUrl: 'https://api.ru.clanhall.net',
});
